import isEqual from 'lodash/isEqual'
import objectPath from 'object-path'

const addFetchOptionRuleUiKey = (keys = [], key) => {
  if (!key) return keys
  if (keys.includes(key)) return keys

  keys.push(key)
  return keys
}

export const createFetchOptionStatus = (status = {}, uiKey = '') => {
  let {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
    formComponentName,
    ruleUiKeys,
    eventKey,
  } = status
  let fetchStatus = {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
    formComponentName,
  }
  let updateRuleUiKeys = Array.isArray(ruleUiKeys) ? [...ruleUiKeys] : []

  addFetchOptionRuleUiKey(updateRuleUiKeys, uiKey)
  if (updateRuleUiKeys.length > 0) {
    fetchStatus.ruleUiKeys = updateRuleUiKeys
  }
  if (objectPath.has(status, 'valueChange')) {
    fetchStatus.valueChange = status.valueChange
  }
  if (eventKey) {
    fetchStatus.eventKey = eventKey
  }

  return fetchStatus
}

const getComparableFetchOptionStatus = (status = {}) => {
  let { forceFetch, ...fetchStatus } = status || {}
  return fetchStatus
}

export const isSameFetchOptionStatus = (current = {}, next = {}) => {
  return isEqual(
    getComparableFetchOptionStatus(current),
    getComparableFetchOptionStatus(next),
  )
}

export const shouldUpdateFetchOptionStatus = ({
  isUiChanged = {},
  key = '',
  formComponentName = '',
  isFetchOption = {},
  fetchStatus = {},
}) => {
  let fetchOptionPath = formComponentName
    ? `${formComponentName}.${key}.isFetchOption`
    : ['isFetchOption', key]
  let renderPath = formComponentName
    ? `${formComponentName}.${key}.isRender`
    : [key, 'isRender']
  let currentFetchOption = objectPath.get(isUiChanged, fetchOptionPath)
  let currentOptionUpdate = objectPath.get(isUiChanged, [
    'optionUpdate',
    key,
  ])
  let isRender = objectPath.get(isUiChanged, renderPath)

  if (!isRender) return true
  if (!isSameFetchOptionStatus(currentFetchOption, isFetchOption)) return true
  if (!isSameFetchOptionStatus(currentOptionUpdate, fetchStatus)) return true

  return false
}
